





































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {InputVisualizationModeSchema} from '@/schema/resource/VisualizationMode/InputVisualizationModeSchema'
import {VisualizationMode} from '@/model/resource/VisualizationMode'
import {PanelUser} from '@/model/resource/PanelUser'
import {$, Helper} from 'simpli-web-sdk'

@Component
export default class PersistVisualizationModeView extends Vue {
  @Prop() id?: string
  @Provide('validator') validator = this.$validator

  visualizationMode = new VisualizationMode()
  schema = new InputVisualizationModeSchema()
  editMode = false

  addNew = false

  async created() {
    await this.populateResource()
  }

  async populateResource() {
    const id = Number(this.id) || null
    if (id) {
      this.editMode = true
      await this.visualizationMode.getVisualizationMode(id)
    }
    this.$await.done('getVisualizationMode')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    const respId = await this.visualizationMode.persistVisualizationMode()
    this.$snotify.success(this.$t('system.success.persist') as string)

    const currentId = Number(this.id) || null
    if (currentId) {
      await this.populateResource()
    } else {
      await this.$router.push({
        path: `/internacional/grupo-visualizador/edit/${respId}`,
      })
      await this.populateResource()
    }
  }

  get fieldsToRender() {
    return this.editMode ? this.schema.editFields : this.schema.inputFields
  }
}
